<template>
  <v-container class="px-0 ma-0 py-3 attachment">
    <v-row no-gutters>
      <v-col cols="12">
        <v-card rounded="lg" class="pa-6" elevation="3">
          <v-row no-gutters>
            <v-col cols="12" class="card-header mb-5">
              <p class="header">Attachments</p>
            </v-col>
            <v-col cols="12">
              <div class="upload-file">
                <p class="mb-3">Upload File</p>
                <v-file-upload
                  density="compact"
                  variant="compact"
                  v-model="file"
                ></v-file-upload>

                <div class="d-flex justify-end">
                  <button
                    :disabled="file === null"
                    @click="uploadFiles"
                    :style="{
                      cursor: file === null ? 'not-allowed' : 'pointer',
                    }"
                  >
                    <v-progress-circular
                      v-if="loading"
                      indeterminate
                      color="#237276"
                      size="20"
                    ></v-progress-circular>
                    Upload
                  </button>
                </div>
              </div>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="12">
              <v-table>
                <thead>
                  <tr>
                    <th class="text-left">File Name</th>
                    <th class="text-left">Uploaded By</th>
                    <th class="text-left">Date</th>
                    <th class="text-left">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(file, index) in files" :key="file.id">
                    <td>
                      <div class="d-flex ga-2">
                        <img :src="getFileIcon(file.file_type)" alt="" />
                        <div class="file-name d-flex flex-column gap-1">
                          <div class="name">
                            {{ file.description || "No description" }}
                          </div>
                          <div class="size text-muted">
                            {{ file.size || "24kb" }}
                          </div>
                        </div>
                      </div>
                    </td>
                    <td>
                      {{ file?.user?.salutation }}/{{ file?.user?.first_name }}
                      {{ file?.user?.last_name }}
                    </td>
                    <td>{{ formatTimestamp(file.created_at) }}</td>

                    <td>
                      <div class="d-flex gap-2">
                        <!-- Menu Component -->
                        <v-menu
                          v-model="menu[file.id]"
                          :close-on-content-click="true"
                          location="end"
                          offset-y
                        >
                          <template v-slot:activator="{ props }">
                            <v-btn variant="text" v-bind="props">
                              <svg
                                width="19"
                                height="36"
                                viewBox="0 0 19 36"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <rect
                                  width="19"
                                  height="36"
                                  rx="4"
                                  fill="white"
                                />
                                <path
                                  d="M11 12C11 12.8284 10.3284 13.5 9.5 13.5C8.67157 13.5 8 12.8284 8 12C8 11.1716 8.67157 10.5 9.5 10.5C10.3284 10.5 11 11.1716 11 12Z"
                                  fill="#666666"
                                />
                                <path
                                  d="M11 18C11 18.8284 10.3284 19.5 9.5 19.5C8.67157 19.5 8 18.8284 8 18C8 17.1716 8.67157 16.5 9.5 16.5C10.3284 16.5 11 17.1716 11 18Z"
                                  fill="#666666"
                                />
                                <path
                                  d="M11 24C11 24.8284 10.3284 25.5 9.5 25.5C8.67157 25.5 8 24.8284 8 24C8 23.1716 8.67157 22.5 9.5 22.5C10.3284 22.5 11 23.1716 11 24Z"
                                  fill="#666666"
                                />
                              </svg>
                            </v-btn>
                          </template>

                          <v-list>
                            <v-list-item
                              @click="
                                downloadFile(file.file_path, file.description)
                              "
                              class="d-flex align-center"
                            >
                              <v-icon left>mdi-download</v-icon>
                              <span>Download</span>
                            </v-list-item>
                            <v-list-item
                              @click="removeFile(index)"
                              class="d-flex align-center"
                            >
                              <v-icon left color="error">mdi-delete</v-icon>
                              <span>Delete</span>
                            </v-list-item>
                            <v-list-item
                              @click="viewFile(index)"
                              class="d-flex align-center"
                            >
                              <v-icon left color="#1E88E5">mdi-eye</v-icon>
                              <span>View</span>
                            </v-list-item>
                          </v-list>
                        </v-menu>

                        <v-btn
                          v-if="file.status === 'completed'"
                          color="error"
                          variant="text"
                          density="comfortable"
                          @click="confirmRemove(index)"
                        >
                          <v-icon left color="error">mdi-close</v-icon>
                          Remove
                        </v-btn>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </v-table>
              <v-dialog v-model="viewDialog" max-width="800">
                <v-card rounded="lg">
                  <v-toolbar color="#237276" dark>
                    <v-toolbar-title>File Preview</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon @click="viewDialog = false">
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-toolbar>

                  <v-card-text
                    class="d-flex justify-center align-center"
                    style="min-height: 400px"
                  >
                    <template v-if="isImage(selectedFile?.file_type)">
                      <v-img
                        :src="getFileUrl(selectedFile?.file_path)"
                        max-width="100%"
                        max-height="500"
                        contain
                      ></v-img>
                    </template>

                    <template v-else-if="isDocument(selectedFile?.file_type)">

                      <iframe
                        :src="`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(
                          getFileUrl(selectedFile?.file_path)
                        )}`"
                        width="100%"
                        height="500"
                        style="border: none"
                      ></iframe>
                    </template>

                    <template v-else>
                        
                      <div class="text-center text-muted">
                        <v-icon size="40">mdi-file</v-icon>
                        <p class="mt-2">
                          Preview not available for this file type
                        </p>
                      </div>
                    </template>
                  </v-card-text>
                </v-card>
              </v-dialog>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { VFileUpload } from "vuetify/labs/VFileUpload";
import FileListComponent from "./FileListComponent.vue";
import apiClient from "@/core/buildRequest";
import { useGeneralStore } from "@/store/General.js";
import imgIcon from "@/assets/images/icons/imgIcon.svg";
import globalICon from "@/assets/images/icons/globalICon.svg";
import fileIcon from "@/assets/images/icons/fileIcon.svg";
import videoIcon from "@/assets/images/icons/videoIcon.svg";

export default {
  name: "AttachementComp",
  components: {
    VFileUpload,
    FileListComponent,
  },
  data() {
    return {
      file: null,
      store: useGeneralStore(),
      loading: false,
      files: [],
      menu: {},
      imgIcon,
      globalICon,
      fileIcon,
      videoIcon,
      // New for modal
      viewDialog: false,
      selectedFile: null,
    };
  },
  methods: {
    uploadFiles() {
      this.loading = true;

      const formData = new FormData();
      // تأكد إن this.files هو File أو File[]
      if (Array.isArray(this.file)) {
        this.file.forEach((file) => {
          formData.append("file", file);
        });
      } else {
        formData.append("file", this.file);
      }

      apiClient
        .post(
          `/leads-managment/upload-file/${this.$route.params.id}`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        )
        .then(() => {
          this.store.showSnackbar("File uploaded successfully", "success");
          this.getFiles();
          this.file = null;
        })
        .catch(() => {
          this.store.showSnackbar("File upload failed", "error");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    async removeFile(index) {
      await apiClient
        .get(
          `/leads-managment/delete-file/${this.$route.params.id}/file=${this.files[index].id}`
        )
        .then(() => {
          this.$emit("remove-file", index);
          this.getFiles();
        });
    },
    viewFile(index) {
      const file = this.files[index];
      this.selectedFile = file;
      this.viewDialog = true;
    },

    isImage(type) {
      const imageTypes = ["jpg", "jpeg", "png", "svg", "webp"];
      return imageTypes.includes(type?.toLowerCase());
    },
    isPdf(type) {
      return type?.toLowerCase() === "pdf";
    },
    isDocument(type) {
      const docs = ["doc", "docx", "xls", "xlsx","pdf","pptx","ppt","csv","txt"];
      return docs.includes(type?.toLowerCase());
    },
    getFileUrl(path) {
      return path ;
      // adjust if your backend returns relative paths
      // if (path.startsWith("http")) return path;
      // return `${import.meta.env.VITE_API_BASE_URL || ""}/${path}`;
    },
    confirmRemove(index) {
      this.fileToRemove = index;
      this.showConfirmDialog = true;
    },
    downloadFile(url, title = "promxa") {
      apiClient
        .get("/leads-managment/download-file", {
          params: { path: url },
          responseType: "blob", // 👈 هذا أهم شيء
        })
        .then((res) => {
          const contentType = res.headers["content-type"];
          const blob = new Blob([res.data], { type: contentType });
          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = title;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        })
        .catch((error) => {
          console.error("File download failed:", error);
        });
    },
    async getFiles() {
      await apiClient
        .get(`/leads-managment/get-files/${this.$route.params.id}`)
        .then((res) => {
          this.files = res.data.data;
        });
    },
    formatTimestamp(timestamp) {
      return new Date(timestamp).toLocaleString();
    },
  },
  mounted() {
    this.getFiles();
  },
  computed: {
    getFileIcon() {
      return (fileType) => {
        const fileTypeMapping = {
          svg: imgIcon,
          png: imgIcon,
          jpg: imgIcon,
          jpeg: imgIcon,
          pdf: fileIcon,
          doc: fileIcon,
          docx: fileIcon,
          mp4: videoIcon,
          mov: videoIcon,
        };
        return fileTypeMapping[fileType] || globalICon;
      };
    },
    hasUploadableFiles() {
      return this.files.some((file) => file.status === "pending");
    },
  },
};
</script>
